import ServicesParallax from "./ServicesParallax";
import { motion } from "framer-motion";

function Services() {
  return (
    <motion.section 
      id="services" 
      className="services-section"
      initial={{ opacity: 0, y: 75 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
    >
      <div className="container">
        <h2 className="main-title text-center">SERVICES</h2>
        <div style={{marginTop: '2rem'}}>
            <ServicesParallax />
        </div>
      </div>
    </motion.section>
  );
}
export default Services;
